<app-dialog [config]="data.config" (actionButtonClicked)="onFormSubmit($event)">
    <ng-container dialog-title>
        <i class="fa fa-money mr-2 text-secondary"></i>
        {{title}}
    </ng-container>

    <ng-container dialog-process-in-progress *ngIf="feesForm && feesForm.form">
        <div *ngIf="isLoading">
            <div class="preloader-wrapper">
                <app-preloader></app-preloader>
            </div>
            <br>
            <span *ngIf="totalItems">Processing account {{currentItem}} of {{totalItems}}</span>
            <span *ngIf="!totalItems">Fetching accounts to process</span>
        </div>
        <div *ngIf="!isLoading">
            <div class="selected-filters">
                <h5>Selected Filters</h5>
                <hr>
                <ul>
                    <li class="card-item">
                        <div class="d-flex w-100">
                            <span class="label">Accounts</span>
                            <span class="value">{{this.data.ignoreSelected ? 'All (max. 1000)' : 'Selected' }}</span>
                        </div>
                    </li>
                    <li *ngFor="let filter of this.selectedFilters" class="card-item">
                        <div class="d-flex w-100">
                            <span class="label">{{filter.label}}</span>
                            <span class="value">{{filter.value}}</span>
                        </div>
                    </li>
                </ul>
            </div>
            <form [formGroup]="feesForm.form">
                <ng-container [formArrayName]="feesForm.feesArraySelector">
                    <ng-container [formGroupName]="'0'">
                        <div *ngIf="!feesForm.controls[0].feeGroup.hidden">
                            <app-select
                                [formControlName]="feesForm.controls[0].feeGroup.name"
                                [control]="feesForm.controls[0].feeGroup"
                            ></app-select>
                        </div>
                        <div *ngIf="!feesForm.controls[0].feeType.hidden" [ngClass]="{'mb-3': feesForm.controls[0].feeType.errors > 0}">
                            <app-select
                                [formControlName]="feesForm.controls[0].feeType.name"
                                [control]="feesForm.controls[0].feeType"
                            ></app-select>
                        </div>
                        <div *ngIf="!feesForm.controls[0].feeType.hidden" [ngClass]="{'mb-3': feesForm.controls[0].fee.errors > 0}">
                            <app-select
                                [formControlName]="feesForm.controls[0].fee.name"
                                [control]="feesForm.controls[0].fee"
                            ></app-select>
                        </div>
                        <ng-container *ngIf="feesForm.isValidityPerAccount">
                            <div *ngIf="!feesForm.controls[0].startDate.hidden"  [ngClass]="{'mb-3': feesForm.controls[0].startDate.errors > 0}">
                                <app-datepicker
                                    [formControlName]="feesForm.controls[0].startDate.name"
                                    [control]="feesForm.controls[0].startDate"
                                ></app-datepicker>
                            </div>
                            <div [ngClass]="{'mb-3': feesForm.controls[0].endDate.errors > 0}">
                                <app-datepicker
                                    [formControlName]="feesForm.controls[0].endDate.name"
                                    [control]="feesForm.controls[0].endDate"
                                ></app-datepicker>
                            </div>
                        </ng-container>
                        <ng-container>
                            <div class="alert alert-warning" role="alert" *ngIf="showDateWarning">
                                Setting a date in the past requires recalculation of this fee plan!
                            </div>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </form>
        </div>
    </ng-container>
</app-dialog>

